// lib/supabase.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Supabase URL y Anon Key son requeridos. Verifica tu archivo .env y reinicia el servidor.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);